import { render, staticRenderFns } from "./header-screen.vue?vue&type=template&id=79cd5087&scoped=true&"
import script from "./header-screen.vue?vue&type=script&lang=js&"
export * from "./header-screen.vue?vue&type=script&lang=js&"
import style0 from "./header-screen.vue?vue&type=style&index=0&id=79cd5087&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cd5087",
  null
  
)

export default component.exports